import { clsx } from "clsx";
import { FC, PropsWithChildren } from "react";

interface DrawerLayoutProps {
  className?: string;
}
const DrawerLayout: FC<PropsWithChildren<DrawerLayoutProps>> = ({ children, className = "" }) => (
  <div className={clsx("tw:relative tw:mx-auto tw:w-full tw:max-w-3xl", className)}>{children}</div>
);

export default DrawerLayout;
